import { render, staticRenderFns } from "./HeatingDaysCard.vue?vue&type=template&id=66a66ad3&scoped=true"
import script from "./HeatingDaysCard.vue?vue&type=script&lang=ts"
export * from "./HeatingDaysCard.vue?vue&type=script&lang=ts"
import style0 from "./HeatingDaysCard.vue?vue&type=style&index=0&id=66a66ad3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a66ad3",
  null
  
)

export default component.exports